import { FC, useEffect, useState } from "react";
import { PaginationResponse } from "../../../types/common";
import { NewsDto, NewsFilter } from "../../../types/news";
import { useConfiguration } from "../../../hooks/useConfiguration";
import { getNews } from "../../../api/transport/newsTransport";
import { extractTextFromHtml, getSiteByTeamCode, getStaticUrl, getUrlByContext } from "../../../utils";
import { LoadingNewsCard, NewsCard } from "../../../components/news/NewsCard";
import { NewsList } from "../../../components/news/NewsList";

interface LatestNewsWidgetProps {
    newsId?: number;
    category?: number;
}

const LATEST_NEWS_COUNT = 9;

export const LatestNewsWidget: FC<LatestNewsWidgetProps> = ({
    newsId,
    category,
}) => {
    const [news, setNews] = useState<PaginationResponse<NewsDto>>();
    const [loading, setLoading] = useState(true);
    const config = useConfiguration();

    useEffect(() => {
        setLoading(true);
        loadNews(category ? { id_cat: +category } : null);
    }, []);

    const loadNews = (filter?: NewsFilter) => {
        setLoading(true);
        getNews(0, LATEST_NEWS_COUNT + 1, getSiteByTeamCode(config.teamName), filter).then((n) => {
            setNews(n);
        }).finally(() => {
            setLoading(false);
        });
    }

    let newsCards = null;

    if (loading) {
        const cards = [];

        for (let i = 0; i < LATEST_NEWS_COUNT; i++) {
            cards.push(<LoadingNewsCard key={`loder_${i}`} />);
        }

        newsCards = (
            <>
                {cards}
            </>
        );
    } else {
        const filteredNews = newsId ? news?.data?.filter(n => n.id !== newsId) : [...news?.data];
        newsCards = filteredNews.map((news) => {
            const content = extractTextFromHtml(news.description).split('.')[0] || ' ';
            return (
                <NewsCard
                    key={news.id}
                    title={news.title}
                    content={content}
                    cover={getStaticUrl(news.image)}
                    date={news.date}
                    category={news.category}
                    url={news.url}
                />
            )
        })
    }

    return (
        <NewsList
            title="Последние новости"
            actionButton={<a
                href={getUrlByContext('/news/', config.teamName)}
                className="transition-all bg-slate-200 px-4 py-2 rounded-full cursor-pointer active:scale-95 hover:bg-sky-600 hover:text-white text-sky-900 hover:no-underline hover:shadow-sm"
                >Все новости</a>}
        >
            {newsCards}
        </NewsList>
    );
}